import { DefaultFile, EmptyDefaultFile } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum BannerFields {
	id = 'id',
	title = 'title',
	link = 'link',
	isActive = 'isActive',
	createDate = 'createDate',
	lastUpdateDate = 'lastUpdateDate'
}

export enum BannerFilterFields {
	includeInactive = 'includeInactive'
}

export enum BannerFormFields {
	title = 'title',
	link = 'link',
	isActive = 'isActive',
	file = 'file'
}

export declare namespace Banner {
	interface Basic {
		[BannerFields.id]: number
		[BannerFields.title]: BasicString
		[BannerFields.link]: BasicString
		[BannerFields.isActive]: boolean
		[BannerFields.createDate]: BasicString
		[BannerFields.lastUpdateDate]: BasicString
	}

	namespace Config {
		interface Filter {
			[BannerFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
		}
	}

	namespace Form {
		interface Add {
			[BannerFormFields.title]: BasicString
			[BannerFormFields.link]: BasicString
			[BannerFormFields.isActive]: boolean
			[BannerFormFields.file]: Nullable<DefaultFile | EmptyDefaultFile>
		}

		interface Valid {
			[BannerFormFields.title]: string
			[BannerFormFields.link]: string
			[BannerFormFields.isActive]: boolean
			[BannerFormFields.file]: DefaultFile
		}
	}

	namespace Request {
		interface Add {
			[BannerFormFields.title]: string
			[BannerFormFields.link]: string
			[BannerFormFields.isActive]: boolean
			[BannerFormFields.file]: Nullable<File>
		}
	}
}
